import React from 'react';

/* eslint-disable */
export function CircleArrowRight(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
      <path
        d="M9 0.8125C4.32422 0.8125 0.5625 4.60938 0.5625 9.25C0.5625 13.9258 4.32422 17.6875 9 17.6875C13.6406 17.6875 17.4375 13.9258 17.4375 9.25C17.4375 4.60938 13.6406 0.8125 9 0.8125ZM14.2734 10.0586L10.6172 13.7148C10.1953 14.1719 9.45703 14.1719 9.03516 13.7148C8.57812 13.293 8.57812 12.5547 9.03516 12.1328L10.7578 10.375H4.5C3.86719 10.375 3.375 9.88281 3.375 9.25C3.375 8.65234 3.86719 8.125 4.5 8.125H10.7578L9.03516 6.40234C8.57812 5.98047 8.57812 5.24219 9.03516 4.82031C9.45703 4.36328 10.1953 4.36328 10.6172 4.82031L14.2734 8.47656C14.5547 8.75781 14.625 9.10938 14.625 9.25C14.625 9.42578 14.5547 9.77734 14.2734 10.0586Z"
        fill="currentColor"
      />
    </svg>
  );
}
